// extracted by mini-css-extract-plugin
module.exports = {"Audio3DPlayer":"kkPYr","audio3DPlayer":"kkPYr","first":"_1QHKQ","second":"-qTkr","gradient":"_2cVXN","icon":"_1OyYe","mediaButton":"_1zdsj","pausing":"SmIRS","playing":"_2qmR5"};